module.exports = __webpack_public_path__ + "img/sodiq.b944f11f.jpeg";